// Extracted to util - so it can be used globally
export var getFilterOptionLabel = function (filterOptions, option, language) {
    var _a;
    var filterOption = filterOptions.find(function (o) { return o.field === option; });
    return ((_a = filterOption === null || filterOption === void 0 ? void 0 : filterOption.localizations) === null || _a === void 0 ? void 0 : _a[language]) || (filterOption === null || filterOption === void 0 ? void 0 : filterOption.name) || '';
};
export var getFilterOptionValue = function (filterRule) {
    if (!filterRule)
        return undefined;
    var textValues = filterRule.textValues, longValues = filterRule.longValues, doubleValues = filterRule.doubleValues, timestampValues = filterRule.timestampValues, localDateValues = filterRule.localDateValues;
    // Finds the first type of values which has some values in list
    return [textValues, longValues, doubleValues, timestampValues, localDateValues]
        .find(function (values) { return values === null || values === void 0 ? void 0 : values.length; });
};
export var filterFilterOptions = function (filterOptions) {
    // banned substrings for Smart data > Stays periods/holidays
    var bannedSmartDataStays = [
        "Winter Stays", "Spring Stays", "Summer Stays", "Autumn Stays",
        "Early Winter Stays", "Mid Winter Stays", "Late Winter Stays",
        "Early Spring Stays", "Mid Spring Stays", "Late Spring Stays",
        "Early Summer Stays", "Mid Summer Stays", "Late Summer Stays",
        "Early Autumn Stays", "Mid Autumn Stays", "Late Autumn Stays",
        "Ski Season Stays", "Beach Season Stays", "Shoulder Season Stays",
        "Off-Peak Season Stays", "Peak Season Stays",
        "Christmas Season Stays", "New Year Period Stays", "Easter Period Stays",
        "Summer Holidays Stays", "Autumn Break Stays", "Spring Break Stays",
        "Rainy Season Stays", "Dry Season Stays", "Monsoon Season Stays",
        "Business Travel Season Stays", "Event Season Stays", "New Year Stays",
        "International Workers' Day Stays", "International Women's Day Stays",
        "Oktoberfest Stays", "St. Patrick's Day Stays", "Bastille Day Stays",
        "St. Andrew's Day Stays", "St. George's Day Stays", "St. David's Day Stays",
        "St. Valentine's Day Stays", "St. Nicholas Day Stays", "Halloween Stays",
        "Valentine's Day Stays", "Black Friday Stays", "Cyber Monday Stays",
        "Thanksgiving Stays", "Independence Day Stays", "Labor Day Stays",
        "Memorial Day Stays", "Presidents' Day Stays", "Columbus Day Stays",
        "Veterans Day Stays", "Mother's Day Stays", "Father's Day Stays",
        "Lunar New Year Stays", "Mid-Autumn Festival Stays", "Dragon Boat Festival Stays",
        "Ramadan Stays", "Easter Stays", "Orthodox Easter Stays",
        "Christmas Stays", "Orthodox Christmas Stays", "Hanukkah Stays",
        "Diwali Stays", "Vesak Stays", "Passover Stays", "Rosh Hashanah Stays",
        "Yom Kippur Stays", "Purim Stays", "Eid al-Fitr Stays",
        "Super Bowl Stays", "World Cup Stays", "Olympics Stays",
        "Winter Olympics Stays", "UEFA Champions League Final Stays", "NBA Finals Stays",
        "World Series Baseball Stays", "Stanley Cup Finals Stays", "Grand Slams Stays",
        "Tour de France Stays", "UEFA Euro Championship Stays",
    ];
    // banned substrings for Smart data > Revenue (first group)
    var bannedSmartDataRevenue = [
        "Loyalty Program Revenue", "Non-Loyalty Program Revenue",
        "Revenue Per Available Room", "Average Daily Rate",
        "Total Room Nights", "Occupancy Rate", "Year-over-Year Growth",
        "Quarter-over-Quarter Growth", "High Season Revenue", "Low Season Revenue",
        "Direct Booking Revenue", "OTA Booking Revenue", "Ancillary Revenue Breakdown",
        "Group Revenue", "Individual Revenue", "Business Revenue", "Leisure Revenue",
        "Total Minibar Revenue", "Average Minibar Revenue Per Stay",
        "Top Percentile Minibar", "Bottom Percentile Minibar",
    ];
    // banned substrings for Smart data (general root-level)
    var bannedSmartDataGeneral = [
        "Meta representative email", "Travel Companions", "Is VIP"
    ];
    // banned substrings for Smart data > Stays (extra fields)
    var bannedSmartDataStaysExtra = [
        "Average Rating", "Review Count", "Periods", "Holidays",
        "Group Stays Count", "Individual Stays Count",
        "Business Stays Count", "Leisure Stays Count",
    ];
    // banned substrings for Smart data > Newsletter
    var bannedSmartDataNewsletter = [
        "Subscribed In Maileon", "Organization name",
        "Month of birth", "Day of birth",
        "Audiences", "Lifecycle mails",
    ];
    // banned substrings for Smart data > Revenue (extra: last stay, avg, percentile)
    var bannedSmartDataRevenueExtra = [
        "Last Stay Length", "Last Stay Total Revenue", "Last Stay Room Revenue",
        "Last Stay Service Revenue", "Last Stay F&B Revenue",
        "Average Per Stay", "Average Per Night", "Median Per Stay",
        "Average Service Revenue Per Stay", "Average Service Revenue Per Night",
        "Top Percentile All", "Bottom Percentile All",
        "Average F&B Revenue Per Stay", "Top Percentile F&B", "Bottom Percentile F&B",
        "Average Spa Revenue Per Stay", "Top Percentile Spa", "Bottom Percentile Spa",
        "Average Room Service Revenue Per Stay", "Top Percentile Room Service", "Bottom Percentile Room Service",
    ];
    // banned substrings for Smart data > Stays (metrics like durations, cancellations, totals)
    var bannedSmartDataStaysMetrics = [
        "Average Days Before Booking", "Average Days Between Stays",
        "Average Stay Duration", "Cancellation Count", "Cancellation Rate",
        "Common Special Requests", "First Stay Date", "Last Stay Date",
        "Longest Stay Duration", "Loyalty Points", "Loyalty Program Member",
        "Next Stay Date", "Shortest Stay Duration", "Stays Last Month",
        "Stays Last Year", "Total Nights",
    ];
    var companyBannedSubstrings = ["VAT Code"];
    var membershipBannedSubstrings = [
        "Current points",
        "Expiration day",
        // "Membership level",
        "Membership number",
    ];
    var globalBannedSubstrings = [
        "Receive SMS",
        "Receive promo calls",
    ];
    // const beforeCount = response.data.length;
    var filtered = filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.filter(function (opt) {
        if (opt.name.startsWith("Smart data > Stays")) {
            return (!bannedSmartDataStays.some(function (substr) { return opt.name.includes(substr); }) &&
                !bannedSmartDataStaysExtra.some(function (substr) { return opt.name.includes(substr); }) &&
                !bannedSmartDataStaysMetrics.some(function (substr) { return opt.name.includes(substr); }));
        }
        if (opt.name.startsWith("Smart data > Revenue")) {
            return (!bannedSmartDataRevenue.some(function (substr) { return opt.name.includes(substr); }) &&
                !bannedSmartDataRevenueExtra.some(function (substr) { return opt.name.includes(substr); }));
        }
        if (opt.name.startsWith("Smart data > Newsletter")) {
            return !bannedSmartDataNewsletter.some(function (substr) { return opt.name.includes(substr); });
        }
        if (opt.name.startsWith("Smart data >")) {
            return !bannedSmartDataGeneral.some(function (substr) { return opt.name.includes(substr); });
        }
        if (opt.name.startsWith("Company >")) {
            return !companyBannedSubstrings.some(function (substr) { return opt.name.includes(substr); });
        }
        if (opt.name.startsWith("Memberships >")) {
            return !membershipBannedSubstrings.some(function (substr) { return opt.name.includes(substr); });
        }
        return !globalBannedSubstrings.includes(opt.name);
    });
    // const afterCount = filtered.length;
    // console.log(
    //     `Filter options: before=${beforeCount}, after=${afterCount}, removed=${beforeCount - afterCount}`
    // );
    // console.log(filtered.map(opt => opt.name));
    return filtered || [];
};
